import Qs from 'query-string'

import { sanitizeFilter } from './utils'

export default $filter => {
  const getLocalities = () => $filter.localities
  const getLocality = () => $filter.locality
  const getSlug = () => $filter.slug
  const getOrderBy = () => $filter.orderBy
  const getFilterUrl = () => {
    const {
      slug,
      selectedLocalities,
      searchId,
      valueRange = {},
      visits,
      noLegalActions,
      noDebts,
      desagio,
      campaigns,
      filters,
      initialFilters,
      orderBy,
      page,
      utm_campaign,
      utm_source,
      utm_medium,
      utm_content,
      surroundingsSearch,
    } = $filter

    let url = '/busca'

    if (selectedLocalities.length > 0 && selectedLocalities[0]) {
      url += `/${selectedLocalities.map(locality => locality.slug).toString()}`
    }

    const customQs = Object.keys(filters).reduce((filterOpts, customFilter) => {
      const currentFilter = filters[customFilter]

      if (currentFilter instanceof Array) {
        const activeSelections = currentFilter
          .filter(({ checked }) => checked)
          .map(({ value }) => value)

        if (activeSelections.length) {
          return {
            ...filterOpts,
            [sanitizeFilter(customFilter)]: activeSelections.map(select =>
              sanitizeFilter(select)
            ),
          }
        }
        return filterOpts
      }

      if (currentFilter) {
        return {
          ...filterOpts,
          [sanitizeFilter(customFilter)]: sanitizeFilter(currentFilter),
        }
      }

      return filterOpts
    }, {})

    delete customQs.maiorValor
    delete customQs.menorValor

    const filterQs = {
      ...customQs,
      ...initialFilters,
    }

    Object.assign(
      filterQs,
      customQs,
      sanitizeFilter({ visits }),
      sanitizeFilter({ noLegalActions }),
      sanitizeFilter({ noLegalActions }),
      sanitizeFilter({ noDebts }),
      sanitizeFilter({ campaigns }),
      sanitizeFilter({ orderBy }),
      sanitizeFilter({ searchId }),
      sanitizeFilter({ page }),
      sanitizeFilter({ valueRange }),
      sanitizeFilter({ desagio, slug }),
      sanitizeFilter({ surroundingsSearch })
    )

    let response =
      Object.keys(filterQs).length === 1
        ? `${url}`
        : `${url}?${Qs.stringify(filterQs, {
            arrayFormat: 'comma',
          })}`

    if (utm_campaign || utm_source || utm_medium || utm_content) {
      response += Object.keys(filterQs).length === 1 ? '?' : '&'
      response = utm_campaign ? `${response}utm_campaign=${utm_campaign}&` : ''
      response = utm_source ? `${response}utm_source=${utm_source}&` : ''
      response = utm_medium ? `${response}utm_medium=${utm_medium}&` : ''
      response = utm_content ? `${response}utm_content=${utm_content}` : ''
    }

    return response.replace(/,/g, '--')
  }

  return {
    getLocalities,
    getLocality,
    getOrderBy,
    getFilterUrl,
    getSlug,
  }
}
